import React from "react";
import { ListGroup, ListGroupItem, Button } from "reactstrap";
import {
  Filter,
  ActionButton
} from "../NewManageUsers/ManagePane/InfoCard/AssignBlockComponents";
import { BeatLoader } from "react-spinners";
import { uniqBy } from 'lodash'

class UsersList extends React.Component {
 
 constructor(props)
 {
   super(props);
   this.state = {
    filter: "",
    error: "",
    loading: ""
  };
this.clearFilter = this.clearFilter.bind(this);
 }
 
  
 
  onChg = ({ target }) => this.setState({ [target.name]: target.value });
  clearFilter (){
    this.setState({filter:""});
  }
  render() {
    const {
      assignedLicense,
      notAssignedLicense,
      users,
      license,
      toggle,
      userType,
      removeOrAddAll,
      addingOrRemovingAll
    } = this.props;
    const { filter, error, loading } = this.state;
    const placeholder = `Search ${userType}${
      notAssignedLicense ? " not" : ""
    } assigned a license...`;
    const buttonText = `${notAssignedLicense ? "Add" : "Remove"} All`;
    const actionType = `${notAssignedLicense ? "add_all" : "remove_all"}`;
    const filterRule = st => !st.fullName ||
      st.fullName.toLowerCase().indexOf(filter.toLowerCase()) > -1
    const filteredUser = uniqBy(users, 'id') //["oops", "Node11", "Jerry", "Zakata", "Colpleted"]
    const filteredStudentList = filteredUser.filter(filterRule);

    return (
      <div>
        <div className="mb-3">
          <Filter
            onChg={this.onChg}
            filter={filter}
            placeholder={placeholder}
            clearFilter = {this.clearFilter}
          />
        </div>
        <Button
          color={`${notAssignedLicense ? "secondary" : "danger"}`}
          onClick={() =>{
            if(filteredStudentList.length > 0)
            {
              removeOrAddAll(actionType, license,filteredStudentList)
            }
            }}
          disabled={addingOrRemovingAll}
        >
          {(addingOrRemovingAll && <BeatLoader loading={true} />) || (
            <div>{buttonText}</div>
          )}
        </Button>
        <div className="student-rows">
          <ListGroup>
            {" "}
            {filteredStudentList.map(
              (user, index) =>
                (user.licenses &&
                  user.licenses[license] &&
                  (assignedLicense && (
                    <ListGroupItem
                      key={`UsersList${index}-remove`}
                      onClick={() => {
                        toggle(user.id, license)}}
                      className="m2clickable"
                    >
                      {user.fullName}
                      <ActionButton
                        notInClass={notAssignedLicense}
                        loading={loading}
                        error={error}
                        disabled={addingOrRemovingAll}
                      />
                    </ListGroupItem>
                  ))) ||
                (((!user.licenses) || (user.licenses && !user.licenses[license])) &&
                  notAssignedLicense && (
                    <ListGroupItem
                    key={`UsersList${index}`} 
                      onClick={() => {
                        toggle(user.id, license);}}
                      className="m2clickable"
                    >
                      {user.fullName}
                      <ActionButton
                        notInClass={notAssignedLicense}
                        loading={loading}
                        error={error}
                        disabled={addingOrRemovingAll}
                      />
                    </ListGroupItem>
                  ))
            )}
          </ListGroup>
        </div>

      </div>
    );
  }
}
export default UsersList;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/UsersList.js